/* eslint-disable indent */
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'umi';
import cl from 'classnames';

import { get } from 'lodash';
// import { BaseSpin } from '@/components';
import { Toast, Swiper, Popup } from 'antd-mobile';
import useGCPI18n from '@/hooks/useGCPI18n';
import useResponsive from '@/hooks/useResponsive';

// import { getDeviceType } from '@/utils/utilsPoint';
import { goBack, onHistoryPush, appUrlJump } from '@/utils/utils';
import Header from '@/components/Header';
import { Clickable } from '@/components';

// import MemberWrapTitleBackIcon from '@/assets/images/memberShipCenter/memberIcon/headerBack.png';
// import basicIcon1 from '@/assets/images/memberShipCenter/memberIcon/basicIcon1.png';
// import basicIcon2 from '@/assets/images/memberShipCenter/memberIcon/basicIcon2.png';
import activityIcon1 from '@/assets/images/memberShipCenter/memberIcon/activityIcon1.png';
import activityIcon2 from '@/assets/images/memberShipCenter/memberIcon/activityIcon2.png';
import activityIcon3 from '@/assets/images/memberShipCenter/memberIcon/activityIcon3.png';
import activityIcon4 from '@/assets/images/memberShipCenter/memberIcon/activityIcon4.png';
import upgradeIcon from '@/assets/images/memberShipCenter/memberIcon/upgradeIcon.png';
import prepaidPatternLocked from '@/assets/images/memberShipCenter/cardPattern/prepaidPattern/locked.png';
import prepaidPatternNormal from '@/assets/images/memberShipCenter/cardPattern/prepaidPattern/normal.png';
import beneIcon1 from '@/assets/images/memberShipCenter/benefitIcon/beneIcon1.png';
import beneIcon2 from '@/assets/images/memberShipCenter/benefitIcon/beneIcon2.png';
// import beneIcon3 from '@/assets/images/memberShipCenter/benefitIcon/beneIcon3.png';
import benefitBack from '@/assets/images/memberShipCenter/memberIcon/benefitBack.png';
import winFlower from '@/assets/images/memberShipCenter/memberIcon/winFlower.png';
import postpaidNormal from '@/assets/images/memberShipCenter/cardPattern/postpaidNormal/normal.png';
import postpaidBlueLocked from '@/assets/images/memberShipCenter/cardPattern/postpaidBlue/locked.png';
import postpaidSilverLocked from '@/assets/images/memberShipCenter/cardPattern/postpaidSilver/locked.png';
import postpaidGoldLocked from '@/assets/images/memberShipCenter/cardPattern/postpaidGold/locked.png';
import postpaidPlatinumLocked from '@/assets/images/memberShipCenter/cardPattern/postpaidPlatinum/locked.png';

// import MedalModal from '../MedalModal';

import styles from './index.less';
import * as fd from '../../models/fakeData';

const Medal = props => {
  // 响应式 hook
  useResponsive();

  const {
    // loading = false,
    // saveMemberData,
    qryUserMMSInfoDXP,
    qryMMSTypeInfoDXP,
    qryUpgradeMethodDXP,
    // medalPopVisible,
    // getUserBadgeInfo,
    // userBadgeInfo,
  } = props;
  // const isDXP = false;
  const GCPI18n = useGCPI18n();
  const swiperRef = useRef(null);

  const [nowLevelIndex, setNowLevelIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState(0);
  const [levelArrList, setLevelArrList] = useState([]);
  const [nowMemInfo, setNowMemInfo] = useState({});
  const [isYu, setIsYu] = useState(true);
  const [useInfo, setUserInfo] = useState({});
  const [isShowUpBtn, setIsShowUpBtn] = useState(false);
  // const [curBadgeList, setCurBadgeList] = useState([]);
  // const [badgeWallList, setBadgeWallList] = useState([]);
  // const [scrollPosition, setScrollPosition] = useState(0);
  const [detailPopVisible, setDetailPopVisible] = useState(false);
  const [upOffer, setUpOffer] = useState(null);
  const [popTitle, setPopTitle] = useState(null);
  const [popContent, setPopContent] = useState(null);

  // useEffect(() => {
  //   if (!medalPopVisible) {
  //     // 当遮罩层关闭时，恢复滚动位置
  //     document.body.style.position = '';
  //     window.scrollTo(0, scrollPosition);
  //   }
  //   // 组件卸载时，移除样式
  //   return () => {
  //     document.body.style.position = '';
  //     window.scrollTo(0, 0);
  //   };
  // }, [medalPopVisible, scrollPosition]);

  // useEffect(() => {
  //   console.log('init', initAppStr, initApp);
  // }, []);

  // useEffect(() => {
  //   const nowGrowth = nowMemInfo?.growthValue ? parseInt(nowMemInfo?.growthValue, 10) : 0;
  //   // console.log(111, nowGrowth);
  //   (levelArrList || []).forEach((item, index) => {
  //     const lastLevelGrowthValue = levelArrList?.[index - 1]?.growthValue
  //       ? parseInt(levelArrList?.[index - 1]?.growthValue, 10)
  //       : 0;
  //     const nowLevelGrowthValue = levelArrList?.[index]?.growthValue
  //       ? parseInt(levelArrList?.[index]?.growthValue, 10)
  //       : 0;
  //     // console.log(222, lastLevelGrowthValue, nowLevelGrowthValue);
  //     if (nowGrowth > lastLevelGrowthValue && nowGrowth < nowLevelGrowthValue && isYu) {
  //       // console.log(333, index);
  //       setActiveIndex(index);
  //       swiperRef?.current?.swipeTo(index);
  //     }
  //   });
  // }, [nowMemInfo, levelArrList, isYu]);

  useEffect(() => {
    const nowLevelCode = nowMemInfo?.levelCode;
    // console.log(111, nowLevelCode);
    (levelArrList || []).forEach((item, index) => {
      if (nowLevelCode === item?.levelCode) {
        // console.log(333, index);
        setNowLevelIndex(index);
        // if (!isYu) {
        setActiveIndex(index);
        swiperRef?.current?.swipeTo(index);
        // }
      }
    });
  }, [nowMemInfo, levelArrList, isYu]);

  const initMemberInfo = () => {
    const initAppStr = window.localStorage.getItem('initApp');
    const initApp = get(JSON.parse(initAppStr), 'userInfo') || JSON.parse(initAppStr) || {};
    setUserInfo({ ...initApp });
    qryUserMMSInfoDXP({}).then(res => {
      if (res && res?.retCode === '0' && res?.data) {
        setNowMemInfo({
          ...nowMemInfo,
          ...res?.data,
          growthValue: res?.data?.growthValue || 0,
        });

        if (res?.data?.membershipTypeId === -10000) {
          setIsYu(true);
        }
        if (res?.data?.membershipTypeId === -10001) {
          setIsYu(false);
        }

        qryMMSTypeInfoDXP(res?.data?.membershipTypeCode).then(memRes => {
          if (memRes && memRes?.retCode === '0') {
            setLevelArrList(memRes?.data?.membershipLevelList || []);
          } else {
            Toast.show({
              icon: 'fail',
              content: memRes?.retDesc || GCPI18n({ id: 'lb_medal_msg_get_user_info_fail' }),
            });
          }
        });
        const payload = {
          membershipTypeCode: res?.data?.membershipTypeCode,
          levelCode: res?.data?.levelCode,
          upgradeType: '1',
        };
        qryUpgradeMethodDXP(payload).then(upRes => {
          if (
            upRes &&
            upRes?.retCode === '0' &&
            upRes?.data?.mmsUpgradeRecomList?.[0]?.upgradeMethod === '1' &&
            upRes?.data?.mmsUpgradeRecomList?.[0]?.mmsUpgradeRecomDetailList?.length > 0
          ) {
            setIsShowUpBtn(true);
            setUpOffer(
              upRes?.data?.mmsUpgradeRecomList?.[0]?.mmsUpgradeRecomDetailList[0]?.recomDetailKey,
            );
          } else {
            setIsShowUpBtn(true);
          }
        });
      } else {
        Toast.show({
          icon: 'fail',
          content: res?.retDesc || GCPI18n({ id: 'lb_medal_msg_get_user_info_fail' }),
        });
      }
    });
  };

  useEffect(() => {
    initMemberInfo();
  }, []);

  // const openMedalPop = record => {
  //   setScrollPosition(window.scrollY || document.documentElement.scrollTop || document.body.scrollTop);
  //   document.body.style.position = 'fixed';
  //   saveMemberData({
  //     medalPopVisible: true,
  //     nowMedalInfo: record,
  //   });
  // };

  const getBgStyle = (value, index) => {
    let style = {};
    if (value?.src) {
      style = { backgroundImage: '', backgroundSize: 'cover' };
      const backgroundImage = new Image();
      backgroundImage.src = value?.src || '';
      style.backgroundImage = `url('${backgroundImage.src}')`;
      style.backgroundSize = 'cover';
    } else {
      style = { background: 'linear-gradient(127.68deg, #dbbb76 0%, #a07330 100%)' };
    }

    if (index === 0) {
      style.background = 'linear-gradient(109.81deg, #6086FF 0%, #2F58DA 81%)';
    }
    if (index === 1) {
      style.background = 'linear-gradient(127.68deg, #A8AFCB 0%, #676B78 100%)';
    }
    if (index === 2) {
      style.background = 'linear-gradient(127.68deg, #dbbb76 0%, #a07330 100%)';
    }
    if (index >= 3) {
      style.background = 'linear-gradient(127.68deg, #8D7CA9 0%, #544270 100%)';
    }
    return style;
  };

  const getNowLevelBgImg = (value, index) => {
    const style = { backgroundImage: '', backgroundSize: 'cover', border: '1px solid transparent' };

    // if (isYu) {
    //   const nowGrowth = nowMemInfo?.growthValue ? parseInt(nowMemInfo?.growthValue, 10) : 0;
    //   const lastLevelGrowthValue = levelArrList?.[index - 1]?.growthValue
    //     ? parseInt(levelArrList?.[index - 1]?.growthValue, 10)
    //     : 0;
    //   if (nowGrowth <= lastLevelGrowthValue) {
    //     const backgroundImage = new Image();
    //     backgroundImage.src = prepaidPatternLocked;
    //     style.backgroundImage = `url('${backgroundImage.src}')`;
    //   } else {
    //     const backgroundImage = new Image();
    //     backgroundImage.src = prepaidPatternNormal;
    //     style.backgroundImage = `url('${backgroundImage.src}')`;
    //   }
    // }

    // if (!isYu) {
    if (index > nowLevelIndex) {
      const backgroundImage = new Image();
      backgroundImage.src = prepaidPatternLocked;
      style.backgroundImage = `url('${backgroundImage.src}')`;
    } else {
      const backgroundImage = new Image();
      backgroundImage.src = prepaidPatternNormal;
      style.backgroundImage = `url('${backgroundImage.src}')`;
    }
    // }

    return style;
  };

  const getHouLevelBgImg = (value, index) => {
    const style = { backgroundImage: '', backgroundSize: 'cover', border: '1px solid transparent' };

    // const nowGrowth = nowMemInfo?.growthValue ? parseInt(nowMemInfo?.growthValue, 10) : 0;
    // const lastLevelGrowthValue = levelArrList?.[index - 1]?.growthValue
    //   ? parseInt(levelArrList?.[index - 1]?.growthValue, 10)
    //   : 0;
    // if (nowGrowth <= lastLevelGrowthValue && activeIndex === 0) {
    //   const backgroundImage = new Image();
    //   backgroundImage.src = postpaidBlueLocked;
    //   style.backgroundImage = `url('${backgroundImage.src}')`;
    // } else if (nowGrowth <= lastLevelGrowthValue && activeIndex === 1) {
    //   const backgroundImage = new Image();
    //   backgroundImage.src = postpaidSilverLocked;
    //   style.backgroundImage = `url('${backgroundImage.src}')`;
    // } else if (nowGrowth <= lastLevelGrowthValue && activeIndex === 2) {
    //   const backgroundImage = new Image();
    //   backgroundImage.src = postpaidGoldLocked;
    //   style.backgroundImage = `url('${backgroundImage.src}')`;
    // } else if (nowGrowth <= lastLevelGrowthValue && activeIndex >= 3) {
    //   const backgroundImage = new Image();
    //   backgroundImage.src = postpaidPlatinumLocked;
    //   style.backgroundImage = `url('${backgroundImage.src}')`;
    // } else {
    //   const backgroundImage = new Image();
    //   backgroundImage.src = postpaidNormal;
    //   style.backgroundImage = `url('${backgroundImage.src}')`;
    // }

    if (index > nowLevelIndex && index === 0) {
      const backgroundImage = new Image();
      backgroundImage.src = postpaidBlueLocked;
      style.backgroundImage = `url('${backgroundImage.src}')`;
    } else if (index > nowLevelIndex && index === 1) {
      const backgroundImage = new Image();
      backgroundImage.src = postpaidSilverLocked;
      style.backgroundImage = `url('${backgroundImage.src}')`;
    } else if (index > nowLevelIndex && index === 2) {
      const backgroundImage = new Image();
      backgroundImage.src = postpaidGoldLocked;
      style.backgroundImage = `url('${backgroundImage.src}')`;
    } else if (index > nowLevelIndex && index >= 3) {
      const backgroundImage = new Image();
      backgroundImage.src = postpaidPlatinumLocked;
      style.backgroundImage = `url('${backgroundImage.src}')`;
    } else {
      const backgroundImage = new Image();
      backgroundImage.src = postpaidNormal;
      style.backgroundImage = `url('${backgroundImage.src}')`;
    }
    return style;
  };

  const addThousandSeparator = number => {
    // 将数字转换为字符串并按小数点分割
    const parts = number?.toString()?.split('.') || '';
    if (parts) {
      // 整数部分加上千分位（从右向左每3位插入逗号）
      const intStr = parts?.[0] || '';
      if (intStr.length > 3) {
        let formatted = '';
        const len = intStr.length;
        for (let i = 0; i < len; i += 1) {
          if (i > 0 && (len - i) % 3 === 0) {
            formatted += ',';
          }
          formatted += intStr[i];
        }
        parts[0] = formatted;
      }
      // 返回加上千分位的数字
      return parts?.join('.') || number;
    }
    return number;
  };

  const getNowLevelWidth = (value, index) => {
    const style = { width: '0px' };
    const nowGrowth = nowMemInfo?.growthValue ? parseInt(nowMemInfo?.growthValue, 10) : 0;
    const lastLevelGrowthValue = levelArrList?.[index - 1]?.growthValue
      ? parseInt(levelArrList?.[index - 1]?.growthValue, 10)
      : 0;
    const nowLevelGrowthValue = levelArrList?.[index]?.growthValue
      ? parseInt(levelArrList?.[index]?.growthValue, 10)
      : 0;
    // console.log('getNowLevelWidth', nowGrowth, lastLevelGrowthValue, nowLevelGrowthValue);
    if (nowGrowth === 0) {
      style.width = '0px';
    } else if (nowGrowth >= nowLevelGrowthValue) {
      style.width = '100%';
    } else if (index === 0) {
      const nowPercent = nowGrowth / nowLevelGrowthValue;
      const widthTmp = Math.floor(nowPercent * 100);
      // console.log('nowPercent1', nowPercent, widthTmp);
      style.width = `${widthTmp}%`;
    } else if (index > 0) {
      const nowPercent =
        (nowGrowth - lastLevelGrowthValue) / (nowLevelGrowthValue - lastLevelGrowthValue);
      const widthTmp = Math.floor(nowPercent * 100);
      // console.log('nowPercent2', nowPercent, widthTmp);
      style.width = `${widthTmp}%`;
    }
    return style;
  };

  const isNeedLockCardBox = () => {
    const style = { opacity: 1 };

    // if (isYu) {
    //   const nowGrowth = nowMemInfo?.growthValue ? parseInt(nowMemInfo?.growthValue, 10) : 0;
    //   const lastLevelGrowthValue = levelArrList?.[activeIndex - 1]?.growthValue
    //     ? parseInt(levelArrList?.[activeIndex - 1]?.growthValue, 10)
    //     : 0;
    //   if (nowGrowth <= lastLevelGrowthValue) {
    //     style.opacity = 0.5;
    //   } else {
    //     style.opacity = 1;
    //   }
    // }

    // if (!isYu) {
    if (activeIndex > nowLevelIndex) {
      style.opacity = 0.5;
    } else {
      style.opacity = 1;
    }
    // }

    return style;
  };

  const isNeedLockCard = () => {
    // if (isYu) {
    //   const nowGrowth = nowMemInfo?.growthValue ? parseInt(nowMemInfo?.growthValue, 10) : 0;
    //   const lastLevelGrowthValue = levelArrList?.[activeIndex - 1]?.growthValue
    //     ? parseInt(levelArrList?.[activeIndex - 1]?.growthValue, 10)
    //     : 0;
    //   // console.log('getNowLevelWidth', nowGrowth, lastLevelGrowthValue, nowLevelGrowthValue);
    //   if (nowGrowth <= lastLevelGrowthValue) {
    //     return false;
    //   }
    //   return true;
    // }

    if (activeIndex > nowLevelIndex) {
      return false;
    }
    return true;
  };

  const isShowUpgrade = () => {
    const style = { display: 'none' };

    // if (isYu) {
    //   const nowGrowth = nowMemInfo?.growthValue ? parseInt(nowMemInfo?.growthValue, 10) : 0;
    //   const nowLevelGrowthValue = levelArrList?.[activeIndex]?.growthValue
    //     ? parseInt(levelArrList?.[activeIndex]?.growthValue, 10)
    //     : 0;
    //   // console.log('getNowLevelWidth', nowGrowth, lastLevelGrowthValue, nowLevelGrowthValue);
    //   if (nowGrowth >= nowLevelGrowthValue || activeIndex === levelArrList?.length - 1) {
    //     style.display = 'none';
    //     return style;
    //   }
    //   if (activeIndex > 0 && activeIndex !== levelArrList?.length - 1) {
    //     style.display = 'flex';
    //     return style;
    //   }
    // }

    // if (!isYu) {
    if (activeIndex < nowLevelIndex || activeIndex === levelArrList?.length - 1) {
      style.display = 'none';
      return style;
    }
    if (activeIndex >= 0 && activeIndex !== levelArrList?.length - 1) {
      style.display = 'flex';
      return style;
    }
    // }

    return style;
  };

  const isShowGrowthValue = (type, index) => {
    const style = { display: 'none' };

    // if (isYu) {
    //   const nowGrowth = nowMemInfo?.growthValue ? parseInt(nowMemInfo?.growthValue, 10) : 0;
    //   const nowLevelGrowthValue = levelArrList?.[index]?.growthValue
    //     ? parseInt(levelArrList?.[index]?.growthValue, 10)
    //     : 0;
    //   const lastLevelGrowthValue = levelArrList?.[index - 1]?.growthValue
    //     ? parseInt(levelArrList?.[index - 1]?.growthValue, 10)
    //     : 0;
    //   if (nowGrowth >= nowLevelGrowthValue && type === 3) {
    //     style.display = 'block';
    //     return style;
    //   }
    //   if (nowGrowth <= lastLevelGrowthValue && type === 2) {
    //     style.display = 'block';
    //     return style;
    //   }
    //   if (nowGrowth < nowLevelGrowthValue && nowGrowth > lastLevelGrowthValue && type === 1) {
    //     style.display = 'block';
    //     return style;
    //   }
    // }

    // if (!isYu) {
    if (index < nowLevelIndex && type === 3) {
      style.display = 'block';
      return style;
    }
    if (index > nowLevelIndex && type === 2) {
      style.display = 'block';
      return style;
    }
    if (index === nowLevelIndex && type === 1) {
      style.display = 'block';
      return style;
    }
    // }
    return style;
  };

  const isHouLocked = (type, index) => {
    const style = { display: 'none' };

    // if (isYu) {
    //   const nowGrowth = nowMemInfo?.growthValue ? parseInt(nowMemInfo?.growthValue, 10) : 0;
    //   const nowLevelGrowthValue = levelArrList?.[index]?.growthValue
    //     ? parseInt(levelArrList?.[index]?.growthValue, 10)
    //     : 0;
    //   const lastLevelGrowthValue = levelArrList?.[index - 1]?.growthValue
    //     ? parseInt(levelArrList?.[index - 1]?.growthValue, 10)
    //     : 0;
    //   if (nowGrowth >= nowLevelGrowthValue && type === 3) {
    //     style.display = 'block';
    //     return style;
    //   }
    //   if (nowGrowth <= lastLevelGrowthValue && type === 2) {
    //     style.display = 'block';
    //     return style;
    //   }
    //   if (nowGrowth < nowLevelGrowthValue && nowGrowth > lastLevelGrowthValue && type === 1) {
    //     style.display = 'block';
    //     return style;
    //   }
    // }

    // if (!isYu) {
    if (index < nowLevelIndex && type === 3) {
      style.display = 'block';
      return style;
    }
    if (index > nowLevelIndex && type === 2) {
      style.display = 'block';
      return style;
    }
    if (index === nowLevelIndex && type === 1) {
      style.display = 'block';
      return style;
    }
    // }
    return style;
  };

  const getBeneCardBgStyle = () => {
    const style = {};
    if (activeIndex === 0) {
      style.background = 'rgba(126, 137, 179, 0.2)';
    }
    if (activeIndex === 1) {
      style.background = 'rgba(126, 137, 179, 0.2)';
    }
    if (activeIndex === 2) {
      style.background = 'rgba(166, 139, 96, 0.2)';
    }
    if (activeIndex >= 3) {
      style.background = 'rgba(141, 126, 160, 0.2)';
    }
    return style;
  };

  const getBeneCardIconStyle = () => {
    const style = {};
    if (activeIndex === 0) {
      style.background = 'linear-gradient(127.68deg, #99A0BD 0%, #676B78 100%)';
    }
    if (activeIndex === 1) {
      style.background = 'linear-gradient(127.68deg, #99A0BD 0%, #676B78 100%)';
    }
    if (activeIndex === 2) {
      style.background = 'linear-gradient(127.68deg, #DBBB76 0%, #A07330 100%)';
    }
    if (activeIndex >= 3) {
      style.background = 'linear-gradient(127.68deg, #8D7CA9 0%, #544270 100%)';
    }
    return style;
  };

  return (
    <div
      className={cl(styles.MemberWrap, styles.androidMemberWrap)}
      // style={{ height: medalPopVisible ? '100%' : 'auto', overflowY: medalPopVisible ? 'hidden' : 'auto' }}
    >
      <Header goBack={goBack} title={GCPI18n({ id: 'lb_member_ship_title' })} />
      {/* <div className={styles.MemberWrapTitle}>
        <span className={styles.MemberWrapTitleBack} onClick={goBack}>
          <img alt="" src={MemberWrapTitleBackIcon} />
        </span>
        <span className={styles.MemberWrapTitleText}>{GCPI18n({ id: 'lb_member_ship_title' })}</span>
        <span />
      </div> */}
      <div
        className={styles.MemberWrapTop}
        // style={
        //   !fd.memberData[activeIndex]?.benefitList || fd.memberData[activeIndex]?.benefitList?.length === 0
        //     ? {
        //         height: '195px',
        //         position: 'relative',
        //         top: '-25px',
        //       }
        //     : {}
        // }
      >
        {isYu && (
          <Swiper
            ref={swiperRef}
            slideSize={80}
            trackOffset={10}
            stuckAtBoundary={false}
            indicator={false}
            style={{
              '--border-radius': '8px',
              // minHeight: '156px',
            }}
            defaultIndex={activeIndex}
            onIndexChange={sInd => {
              setActiveIndex(sInd);
            }}
          >
            {(levelArrList || []).map((item, index) => (
              <Swiper.Item key={index}>
                <div
                  className={styles.dashCardLevelBox}
                  // style={
                  //   !fd.memberData?.[index]?.benefitList || fd.memberData?.[index]?.benefitList?.length === 0
                  //     ? {
                  //         position: 'relative',
                  //         top: '25px',
                  //       }
                  //     : {}
                  // }
                >
                  <div className={styles.dashCardTop} style={getBgStyle(item, index)}>
                    <div className={styles.dashCardTopBg} style={getNowLevelBgImg(item, index)}>
                      <div className={styles.dashCardTitle}>{item?.levelName || '-'}</div>
                      <div className={styles.dashCardNumBox} style={isShowGrowthValue(1, index)}>
                        <span>{GCPI18n('lb_member_ship_growth_value')}</span>
                        <span>{addThousandSeparator(nowMemInfo?.growthValue) || 0}</span>
                        {levelArrList?.length - 1 !== index && <span>/</span>}
                        {levelArrList?.length - 1 !== index && (
                          <span>
                            {addThousandSeparator(levelArrList[index + 1]?.growthValue - 1) || 0}
                          </span>
                        )}
                      </div>
                      <div
                        className={styles.dashCardNumBoxLocked}
                        style={isShowGrowthValue(2, index)}
                      >
                        <span>{item?.levelName || '-'}</span>
                        <span>{GCPI18n('lb_member_ship_level_locked')}</span>
                      </div>
                      <div className={styles.dashCardNumBoxWin} style={isShowGrowthValue(3, index)}>
                        <span>
                          <img src={winFlower} alt="" />
                        </span>
                        <span>{GCPI18n('lb_member_ship_passed_success')}</span>
                      </div>
                      <div className={styles.dashCardProcess}>
                        <span
                          className={styles.dashCardProcessNow}
                          style={getNowLevelWidth(item, index)}
                        />
                        {/* <span className={styles.dashCardProcessPointStart} />
                            <span className={styles.dashCardProcessPointEnd} /> */}
                      </div>
                      <div className={styles.dashCardProcessText}>
                        {/* <span>Validity Till 12-22 2022</span> */}
                        <span />
                        {levelArrList?.length - 1 !== index && index > nowLevelIndex && (
                          <span>{GCPI18n('lb_member_ship_upgrade_level')}</span>
                        )}
                        {levelArrList?.length - 1 !== index && index === nowLevelIndex && (
                          <span>
                            +
                            {`${addThousandSeparator(
                              parseInt(
                                levelArrList[index + 1]?.growthValue - nowMemInfo?.growthValue,
                                10,
                              ),
                            )} `}
                            {GCPI18n('lb_member_ship_upgrade_level')}
                          </span>
                        )}
                        {levelArrList?.length - 1 === index && (
                          <span>{GCPI18n('lb_member_ship_top_level')}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  {fd.memberData?.[index]?.benefitList &&
                    fd.memberData?.[index]?.benefitList?.length > 0 && (
                      <div
                        className={styles.dashCardBottom}
                        style={
                          index === activeIndex
                            ? {}
                            : {
                                display: 'none',
                              }
                        }
                      >
                        {(fd.memberData?.[index]?.benefitList || []).map((benIt, benInd) => (
                          <div className={styles.dashCardIconBtn} key={benInd}>
                            {benIt?.src && (
                              <div className={styles.dashCardIconBtnIcon}>
                                <img src={benIt?.src || ''} alt="" />
                              </div>
                            )}
                            {!benIt?.src && (
                              <div className={styles.dashCardIconBtnIconEmpty}>icon</div>
                            )}
                            <div className={styles.dashCardIconBtnText}>
                              {benIt?.iconName || '-'}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              </Swiper.Item>
            ))}
          </Swiper>
        )}
        {!isYu && (
          <Swiper
            ref={swiperRef}
            slideSize={80}
            trackOffset={10}
            stuckAtBoundary={false}
            indicator={false}
            style={{
              '--border-radius': '8px',
              // minHeight: '100px',
            }}
            defaultIndex={activeIndex}
            onIndexChange={sInd => {
              setActiveIndex(sInd);
            }}
          >
            {(levelArrList || []).map((item, index) => (
              <Swiper.Item key={index}>
                <div className={styles.dashCardLevelBox}>
                  <div className={styles.dashCardTop} style={getBgStyle(item, index)}>
                    <div className={styles.dashCardTopBg} style={getHouLevelBgImg(item, index)}>
                      <div className={styles.dashCardTitle}>{item?.levelName || '-'}</div>
                      <div className={styles.dashCardUserInfo} style={isHouLocked(1, index)}>
                        <div className={styles.dashCardUserText}>
                          <span>·</span>
                          {useInfo?.userName || useInfo?.userId || '-'}
                        </div>
                        <div className={styles.dashCardUserText}>
                          <span>·</span>
                          {useInfo?.mobile || useInfo?.phone || '-'}
                        </div>
                      </div>
                      <div className={styles.dashCardNumBoxLocked} style={isHouLocked(2, index)}>
                        <span>{item?.levelName || '-'}</span>
                        <span>{GCPI18n('lb_member_ship_level_lock')}</span>
                      </div>
                      <div className={styles.dashCardNumBoxWin} style={isHouLocked(3, index)}>
                        <span>
                          <img src={winFlower} alt="" />
                        </span>
                        <span>{GCPI18n('lb_member_ship_passed_success')}</span>
                      </div>
                    </div>
                  </div>
                  {fd.memberData?.[index]?.benefitList &&
                    fd.memberData?.[index]?.benefitList?.length > 0 && (
                      <div
                        className={styles.dashCardBottom}
                        style={
                          index === activeIndex
                            ? {}
                            : {
                                display: 'none',
                              }
                        }
                      >
                        {(fd.memberData?.[index]?.benefitList || []).map((benIt, benInd) => (
                          <div className={styles.dashCardIconBtn} key={benInd}>
                            {benIt?.src && (
                              <div className={styles.dashCardIconBtnIcon}>
                                <img src={benIt?.src || ''} alt="" />
                              </div>
                            )}
                            {!benIt?.src && (
                              <div className={styles.dashCardIconBtnIconEmpty}>icon</div>
                            )}
                            <div className={styles.dashCardIconBtnText}>
                              {benIt?.iconName || '-'}
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                </div>
              </Swiper.Item>
            ))}
          </Swiper>
        )}
      </div>
      <div
        className={styles.MemberWrapCardBox}
        style={isNeedLockCardBox()}
        // style={
        //   activeIndex === 0 ||
        //   !fd.memberData?.[activeIndex]?.benefitList ||
        //   fd.memberData?.[activeIndex]?.benefitList?.length === 0
        //     ? {
        //         position: 'relative',
        //         top: '-45px',
        //         ...isNeedLockCardBox(),
        //       }
        //     : { ...isNeedLockCardBox() }
        // }
      >
        <div className={styles.MemberWrapCardBoxTitle}>
          {GCPI18n('lb_member_ship_benefit_and_rewards')}
        </div>
        {/* <div className={styles.MemberWrapCardItemRow}>
          <div className={styles.MemberWrapCardItemTwo}>
            <img alt="" src={basicIcon1} />
          </div>
          <div className={styles.MemberWrapCardItemTwo}>
            <img alt="" src={basicIcon2} />
          </div>
        </div> */}
        {/* <div className={styles.MemberWrapCardItemRow}>
          <div className={styles.MemberWrapCardItemTwo}>
            <img alt="" src={} />
          </div>
          <div className={styles.MemberWrapCardItemTwo}>
            <img alt="" src={} />
          </div>
        </div> */}
        <div className={styles.MemberWrapCardItemRow}>
          <Clickable
            className={styles.MemberWrapCardItemCus}
            style={getBeneCardBgStyle()}
            onClick={() => {
              setPopTitle(GCPI18n('lb_member_ship_points_multiple'));
              const benList = levelArrList[activeIndex]?.membershipLevelBenefitList || [];
              const benItem = benList?.filter(item => parseInt(item?.benefitType, 10) === 2);
              const benContent = benItem[0]?.comments;
              setPopContent(benContent);
              setTimeout(() => {
                setDetailPopVisible(true);
              }, 100);
            }}
          >
            <div className={styles.MemberWrapCardItemIcon}>
              <span style={getBeneCardIconStyle()}>
                <img src={beneIcon1} alt="" style={{ width: '18px', height: '18px' }} />
              </span>
              <span>
                <img src={benefitBack} alt="" />
              </span>
            </div>
            <div className={styles.MemberWrapCardItemTitle}>
              {GCPI18n('lb_member_ship_points_multiple')}
            </div>
            <div className={styles.MemberWrapCardItemText}>
              {GCPI18n('lb_member_ship_points_multiple_earned')}
            </div>
          </Clickable>
          {activeIndex >= 2 && (
            <Clickable
              className={styles.MemberWrapCardItemCus}
              style={getBeneCardBgStyle()}
              onClick={() => {
                setPopTitle(GCPI18n('lb_member_ship_offer_discount'));
                const benList = levelArrList[activeIndex]?.membershipLevelBenefitList || [];
                const benItem = benList?.filter(item => parseInt(item?.benefitType, 10) === 3);
                const benContent = benItem[0]?.comments;
                setPopContent(benContent);
                setTimeout(() => {
                  setDetailPopVisible(true);
                }, 100);
              }}
            >
              <div className={styles.MemberWrapCardItemIcon}>
                <span style={getBeneCardIconStyle()}>
                  <img src={beneIcon2} alt="" style={{ width: '24px', height: '24px' }} />
                </span>
                <span>
                  <img src={benefitBack} alt="" />
                </span>
              </div>
              <div className={styles.MemberWrapCardItemTitle}>
                {GCPI18n('lb_member_ship_offer_discount')}
              </div>
              <div className={styles.MemberWrapCardItemText}>
                {GCPI18n('lb_member_ship_offer_receive')}
              </div>
            </Clickable>
          )}
          {activeIndex < 2 && (
            <Clickable
              className={styles.MemberWrapCardItemCus}
              style={getBeneCardBgStyle()}
              onClick={() => {
                setPopTitle(GCPI18n('lb_member_ship_customer_service'));
                const benList = levelArrList[activeIndex]?.membershipLevelBenefitList || [];
                const benItem = benList?.filter(item => parseInt(item?.benefitType, 10) === 4);
                const benContent = benItem[0]?.comments;
                setPopContent(benContent);
                setTimeout(() => {
                  setDetailPopVisible(true);
                }, 100);
              }}
            >
              <div className={styles.MemberWrapCardItemIcon}>
                <span style={getBeneCardIconStyle()}>
                  <img src={beneIcon2} alt="" style={{ width: '24px', height: '24px' }} />
                </span>
                <span>
                  <img src={benefitBack} alt="" />
                </span>
              </div>
              <div className={styles.MemberWrapCardItemTitle}>
                {GCPI18n('lb_member_ship_customer_service')}
              </div>
              <div className={styles.MemberWrapCardItemText}>
                {GCPI18n('lb_member_ship_customer_service')}
              </div>
            </Clickable>
          )}
        </div>
        {activeIndex <= 2 && (
          <Clickable
            className={styles.MemberWrapCardItemRow}
            onClick={() => {
              if (isNeedLockCard()) {
                onHistoryPush('/memberShipCenterMyRewards', {
                  membershipTypeCode: nowMemInfo.membershipTypeCode,
                });
              }
            }}
          >
            <div className={styles.MemberWrapCardItemOne}>
              <img alt="" src={activityIcon1} />
            </div>
          </Clickable>
        )}
        {activeIndex > 1 && (
          <Clickable
            className={styles.MemberWrapCardItemRow}
            onClick={() => {
              if (isNeedLockCard()) {
                // appUrlJump('/?promotionId=2489', true);
                onHistoryPush('/', {
                  promotionId: 2489,
                });
              }
            }}
          >
            <div className={styles.MemberWrapCardItemOne}>
              <img alt="" src={activityIcon2} />
            </div>
          </Clickable>
        )}
        {activeIndex > 2 && (
          <div className={styles.MemberWrapCardItemRow}>
            <div className={styles.MemberWrapCardItemOne}>
              <img alt="" src={activityIcon3} />
            </div>
          </div>
        )}
        {activeIndex > 2 && (
          <Clickable
            className={styles.MemberWrapCardItemRow}
            onClick={() => {
              if (isNeedLockCard()) {
                onHistoryPush('/memberShipCenterMyRewards', {
                  membershipTypeCode: nowMemInfo.membershipTypeCode,
                });
              }
            }}
          >
            <div className={styles.MemberWrapCardItemOne}>
              <img alt="" src={activityIcon4} />
            </div>
          </Clickable>
        )}
      </div>
      {isShowUpBtn && (
        <Clickable
          className={styles.MemberWrapUpgradeBtn}
          style={isShowUpgrade()}
          onClick={() => {
            appUrlJump(`/clp_purchase/confirm?offerNbr=${upOffer}&proactivelyUpgradeFlag=Y`, true);
          }}
        >
          <span>
            <img src={upgradeIcon} alt="" />
          </span>
          <span>{GCPI18n('lb_member_ship_upgrade_now')}</span>
        </Clickable>
      )}
      {/* {medalPopVisible && (
        <MedalModal
          handleRrfreshData={initBadgeInfo}
          isNeedShare={['3', '4'].includes(userBadgeInfo?.getBadgeRewardMethod)}
          getBadgeRewardMethod={userBadgeInfo?.getBadgeRewardMethod}
        />
      )} */}
      <Popup
        visible={detailPopVisible}
        showCloseButton
        bodyStyle={{
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          height: '6rem',
        }}
        onClose={() => {
          setDetailPopVisible(false);
        }}
      >
        <div className={styles.benefitPopBox}>
          <div className={styles.benefitPopTitle}>{popTitle}</div>
          {/* eslint-disable react/no-danger */}
          <div
            className={styles.benefitPopContent}
            dangerouslySetInnerHTML={{ __html: popContent }}
          />
          {/* eslint-enable react/no-danger */}
          {/* <div
            className={styles.serveNumPopBtn}
            onClick={() => {
              setDetailPopVisible(false);
            }}
          >
            Close
          </div> */}
        </div>
      </Popup>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  saveMemberData: payload =>
    dispatch({
      type: 'memberShipCenter/save',
      payload,
    }),
  qryUserMMSInfoDXP: payload =>
    dispatch({
      type: 'memberShipCenter/qryUserMMSInfoDXP',
      payload,
    }),
  qryMMSTypeInfoDXP: payload =>
    dispatch({
      type: 'memberShipCenter/qryMMSTypeInfoDXP',
      payload,
    }),
  qryUpgradeMethodDXP: payload =>
    dispatch({
      type: 'memberShipCenter/qryUpgradeMethodDXP',
      payload,
    }),
});

export default connect(
  // ({ memberShipCenter, loading }) => ({
  ({ memberShipCenter, index }) => ({
    medalPopVisible: memberShipCenter.medalPopVisible,
    userBadgeInfo: memberShipCenter.userBadgeInfo,
    product: index.product,
    userDimension: index.userDimension,
    // loading: loading.effects['memberShipCenter/getPointOrderList'],
  }),
  mapDispatchToProps,
)(Medal);
